import { ViewModuleType } from '@Portal/models/ViewModuleType';
import { FilterDimension } from '@Portal/models/smartFilters/FilterDimension';
import { SmartFilterSelectionViewModel } from '@Portal/models/smartFilters/SmartFilterSelectionViewModel';
import { useAxios } from '@Shared/composables/useAxios';
import { usePortalUri } from '@Shared/composables/usePortalUri';

export interface ViewConfiguration {
  moduleType: ViewModuleType;
  moduleId: string;
  subViewName?: string;
}

const axios = useAxios();

export const getSmartFilters = async (
  smartDataModuleId: string,
  data: SmartFilterSelectionViewModel,
  viewConfiguration?: ViewConfiguration,
  signal?: AbortSignal
) => {
  const portalUri = usePortalUri();
  let url = `${portalUri}/api/smartdata/filters/${smartDataModuleId}`;
  if (viewConfiguration) {
    const { moduleType, moduleId, subViewName } = viewConfiguration;
    url += `/${moduleType}/${moduleId}`;
    if (subViewName) url += `/${subViewName}`;
  }
  const response = await axios.post<FilterDimension[]>(url, data, { signal });
  return response.data;
};

export const getSmartFilterWithPattern = async (
  smartDataModuleId: string,
  data: SmartFilterSelectionViewModel,
  filterKey: string,
  filterValueContains: string,
  viewConfiguration?: ViewConfiguration
) => {
  const portalUri = usePortalUri();
  let url = `${portalUri}/api/smartdata/filter/${smartDataModuleId}`;
  if (viewConfiguration) {
    const { moduleType, moduleId, subViewName } = viewConfiguration;
    url += `/${moduleType}/${moduleId}`;
    if (subViewName) url += `/${subViewName}`;
  }
  data.filterDimensionSelection = {
    filterKey: filterKey,
    dimensionValueContains: filterValueContains,
  };

  const response = await axios.post<FilterDimension>(url, data);
  return response.data;
};
